<template>
  <CRow>
    <CCol sm="12" class="rowSegments mt-4">
      <CRow class="rowSegments">
        <CCol sm="12">
          <CRow>
            <CCol sm="12">
              <h1 class="mb-4 mt-5 titlePage font-weight-normal text-capitalize" style="color: #22252b">
                {{ $t('audience.segment.create.header') }}
              </h1>
              <CAlert :color="alertClass" closeButton v-if="alertMessage" :show.sync="currentAlertCounter">
                <center>
                  <strong>{{ alertMessage }}</strong>
                </center>
                <CProgress :max="10" :value="currentAlertCounter" height="3px" :color="alertClass" animate />
              </CAlert>
              <p class="boxTitle mt-3">{{ $t('audience.segment.create.subtitle') }}</p>
              <div class="d-flex flex-column mb-4">
                <div class="d-flex justify-content-end">
                  <button @click="openModalConfirmCancel" class="btn btn-white font-sm py-3 px-5 text-gray-700" style="position: relative">
                    {{ $t('audience.segment.create.btn.cancel') }}
                  </button>
                  <transition name="fade" v-if="modalConfirmCancel">
                    <div class="dataTable__popUp popUp" style="top: 205px">
                      <div class="popUp__body shadow-sm">
                        <div class="confirmationDelete">
                          <div class="confirmationDelete__header">
                            <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                              {{ $t('audience.segment.create.btn.cancel') }}
                            </p>
                          </div>
                          <div class="confirmationDelete__body">
                            <p class="confirmationDelete__description text-gray-700">
                              {{ $t('audience.segment.create.text.click-confirm') }}
                            </p>
                          </div>
                          <div class="confirmationDelete__footer">
                            <div class="confirmationDelete__actions">
                              <CButton class="confirmationDelete__btn btn btn-primary" @click="$router.go(-1)">
                                {{ $t('audience.segment.create.btn.confirm') }}
                              </CButton>
                              <CButton class="confirmationDelete__btn" @click="closeModalCancel" type="link">
                                {{ $t('audience.segment.create.btn.cancel') }}
                              </CButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="12">
          <CRow>
            <CCol sm="12">
              <template v-for="(seg, indexSeg) in segments.values">
                <div class="segmentBlock" v-for="(item, indexOr) in seg.values" :key="indexOr + '-' + (segments.values.length + 1)">
                  <div class style="max-width: 95%">
                    <CSelect
                      :placeholder="$t('audience.segment.create.btn.select')"
                      class="m-2 d-inline-block"
                      :options="getGroupOptions"
                      :value.sync="item.group"
                      @change="changeGroup($event.target.value, indexSeg, indexOr)"
                    />
                    <CSelect
                      v-if="item.group !== null"
                      :placeholder="$t('audience.segment.create.btn.select')"
                      class="m-2 d-inline-block"
                      :options="getValueByGroupName(item.group)"
                      :value.sync="item.key"
                      @change="addKey($event.target.value, indexSeg, indexOr)"
                    />

                    <template
                      v-if="
                        (item.key && getKeyType(item.key) === 'STRING') ||
                        (item.key && getKeyType(item.key) === 'EMAIL') ||
                        (item.key && getKeyType(item.key) === 'MSISDN') ||
                        (item.key && getKeyType(item.key) === 'NUMBER') ||
                        (item.key && getKeyType(item.key) === 'TAGS')
                      "
                    >
                      <CSelect
                        :key="item.key + 'operator'"
                        placeholder="Select"
                        class="m-2 d-inline-block"
                        :options="getOperationsInKeyGroup(item.key)[0]"
                        :value.sync="item.next.op"
                        @change="changeOperator($event.target.value, indexSeg, indexOr)"
                      />

                      <CInput
                        placeholder="write here..."
                        class="d-inline-block m-2"
                        :value.sync="item.next.value"
                        @keyup="addTextValueToJson(indexSeg, indexOr, $event.target.value)"
                        @focusout="getClientOverview(true)"
                        v-if="item.key != '_MetaData.Tags'"
                      />

                      <CSelect
                        v-if="item.key == '_MetaData.Tags'"
                        placeholder="Select a tag"
                        class="m-2 d-inline-block"
                        :options="tags"
                        :value.sync="item.next.value"
                        @focusout="getClientOverview(true)"
                        @change="addTagValueToJson(indexSeg, indexOr, $event.target.value)"
                      />
                    </template>

                    <template v-if="item.key && getKeyType(item.key) === 'DATE'">
                      <!-- <CSelect
                        :key="item.key + 'operator'"
                        placeholder="Select"
                        class="m-2 d-inline-block"
                        :options="getOperationsInKeyGroup(item.key)[0]"
                        :value.sync="form[item.op + indexSeg + indexOr + 'operator']"
                        @change="changeOperator(form[item.op + indexSeg + indexOr + 'operator'], indexSeg, indexOr)"
                      /> -->
                      <CSelect
                        :key="item.key + 'operator'"
                        placeholder="Select"
                        class="m-2 d-inline-block"
                        :options="getOperationsInKeyGroup(item.key)[0]"
                        :value.sync="form[item.op + indexSeg + indexOr + 'operator']"
                        @change="changeOperator($event.target.value, indexSeg, indexOr)"
                      />
                      <CInput
                        type="date"
                        horizontal
                        class="d-inline-block m-2"
                        style="min-width: 235px"
                        v-model="inputCustom"
                        @input="addDateToJson(indexSeg, indexOr)"
                      />
                    </template>

                    <template v-if="item.key && getKeyType(item.key) === 'BOOLEAN'">
                      <CSelect
                        :key="item.key + 'operator'"
                        placeholder="Select"
                        class="m-2 d-inline-block"
                        :options="getOperationsInKeyGroup(item.key)[0]"
                        :value.sync="form[item.op + indexSeg + indexOr + 'operator']"
                        @change="changeOperator(form[item.op + indexSeg + indexOr + 'operator'], indexSeg, indexOr)"
                      />
                      <CSelect
                        :key="item.key + 'input'"
                        placeholder="Select"
                        class="m-2 d-inline-block"
                        :options="getValuesInKeyGroup(item.key)"
                        :value.sync="form[item.selected + item.key + indexSeg + indexOr + 'value']"
                        @change="addKey3(form[item.selected + item.key + indexSeg + indexOr + 'value'], indexSeg, indexOr)"
                      />
                    </template>
                    <br />
                    <br />
                    <div v-if="seg.values.length - 1 == indexOr">
                      <button @click="addOrCondition(indexSeg)" class="btn mt-2" style="padding: 0px; margin: 0px">
                        <img style="width: 25px; height: 25px; margin-top: -10px" src="img/site/addCondition.png" />
                      </button>
                      <span class="addText text-uppercase"> {{ $t('audience.segment.conditions.or') }}</span>
                    </div>
                  </div>

                  <div class="col-1 closeCondition">
                    <span @click="deleteOrCondition(indexSeg, indexOr)" class="closeConsitionBtn"> x </span>
                  </div>
                  <span v-if="indexOr > 0 && seg.values.length - 1 > 0" class="newPlus text-uppercase">
                    {{ $t('audience.segment.conditions.or') }}
                  </span>
                </div>
                <div :key="indexSeg + segments.values.length" class="line">
                  <span v-if="segments.values.length - 1 > 0 && segments.values.length - 1 != indexSeg" class="lineAndNew text-uppercase">
                    {{ $t('audience.segment.conditions.and') }}
                  </span>
                  <span v-if="segments.values.length - 1 == indexSeg" class="lineAndDisabled text-uppercase">
                    {{ $t('audience.segment.conditions.and') }}
                  </span>
                </div>
              </template>

              <div class="btnAddAnd mb-5" @click="addCondition()">
                <img src="img/site/addCondition.png" />
                <span class="text-uppercase">
                  {{ $t('audience.segment.conditions.and-a-conditions') }}
                </span>
              </div>

              <div class="col-md-12 mb-1">
                <div class="d-flex justify-content-between mb-3">
                  <div class="">
                    <button @click="openModalSaveSegment" class="btn btn-primary btn-segment-create text-uppercase">
                      {{ $t('audience.segment.create.btn.creat-segment') }}
                    </button>
                    <transition name="fade" v-if="modalSaveSegment">
                      <div class="dataTable__popUp popUp" style="margin-top: 0px">
                        <div class="popUp__body shadow-sm">
                          <div class="confirmationDelete">
                            <div class="confirmationDelete__header">
                              <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                                {{ $t('audience.segment.create.text.enter-segment') }}
                              </p>
                            </div>
                            <div class="confirmationDelete__body mb-4">
                              <input type="text" class="form-control" v-model="segmentName" />
                            </div>
                            <div class="confirmationDelete__footer">
                              <div class="confirmationDelete__actions">
                                <CButton
                                  :class="btnSaveSegmentClicked ? 'disabled' : false"
                                  class="confirmationDelete__btn btn btn-primary"
                                  @click="createSegment"
                                >
                                  {{ $t('audience.segment.create.btn.confirm') }}
                                </CButton>
                                <CButton class="confirmationDelete__btn" @click="closeModalSaveSegment" type="link">
                                  {{ $t('audience.segment.create.btn.cancel') }}
                                </CButton>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>

                  <!-- <div class="" v-if="overview.contacts">
                    <span class="numberListSegment"
                      >{{ overview.contacts }}
                      <span style="font-size: 14px"
                        >CONTACTS MATCH YOUR CONDITIONS</span
                      ></span
                    >
                  </div>-->
                </div>
              </div>
              <CCard class="dataTable" v-if="recipients.length">
                <CCardBody class="dataTable__body p-0">
                  <CDataTable
                    :items="recipients"
                    :fields="headers"
                    :table-filter="{ external: true, lazy: true }"
                    items-per-page-select
                    :items-per-page.sync="count"
                    @pagination-change="paginationChange"
                    :active-page="1"
                    hover
                    :loading="loading"
                  >
                    <template #loading>
                      <div class="d-flex justify-content-center align-items-center dataTable__loading">
                        <CSpinner class="my-3" color="primary" />
                      </div>
                    </template>

                    <template #_MetaData="{ item }">
                      <OptInOut :opt="{ item }" :key="item.RecipientId" />
                    </template>

                    <template #_MetaData.Tags="{ item }">
                      <Tags :opt="{ item }" />
                    </template>

                    <template #_MetaData.UpdatedDatetime="{ item }">
                      <UpdatedDatetime :opt="{ item }" />
                    </template>
                  </CDataTable>
                </CCardBody>
                <div class="position-relative w-100">
                  <CPagination
                    v-show="pagination.totalPages > 0"
                    :pages="pages"
                    class="dataTable__pagination"
                    :class="{ [$style.blockClick]: this.loadingRecipients }"
                    :doubleArrows="false"
                    :active-page.sync="page"
                    ref="pagination"
                  >
                    <template slot="previous-button">
                      <span class="pagination__button p-2">
                        <i class="icon fas fa-angle-left font-weight-light fa-2x text-gray-500"></i>
                      </span>
                    </template>

                    <template slot="next-button">
                      <span class="pagination__button p-2">
                        <i class="icon fas fa-angle-right font-weight-light fa-2x text-gray-500"></i>
                      </span>
                    </template>
                    <CElementCover v-if="loadingRecipients" :opacity="0.8" style="z-index: 1001">
                      <div></div>
                    </CElementCover>
                  </CPagination>
                </div>

                <div v-if="pagination.totalPages > 0" class="page-item d-flex justify-content-center paginationDetail text-gray-600">
                  {{ pagination.page }} {{ $t('general.components.pagination.of') }} {{ pagination.totalPages }}
                </div>
              </CCard>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
const columnAplication = [
  { key: '_MetaData', label: 'opt in  & opt out' },
  { key: '_MetaData.Tags', label: 'Tags' },
  {
    key: '_MetaData.UpdatedDatetime',
    label: 'LAST CHANGE',
    _style: 'min-width:200px',
  },
]

import services from '@/services.js'
import OptInOut from '@/components/table/OptInOut'
import Tags from '@/components/table/Tags'
import UpdatedDatetime from '@/components/table/UpdatedDatetime'
export default {
  name: 'Segments',
  components: {
    OptInOut,
    Tags,
    UpdatedDatetime,
  },
  data() {
    return {
      timeoutOverview: null,
      segmentName: '',
      groupName: '',
      currentAlertCounter: 10,
      alertMessage: '',
      alertClass: '',
      form: [['']],
      inputText: [['']],
      inputCustom: '',
      segments: {
        op: 'and',
        values: [
          {
            op: 'or',
            values: [
              {
                group: null,
                key: '',
                value: '',
                op: '',
                next: {
                  key: '',
                  value: '',
                  op: '',
                  next: {},
                },
              },
            ],
          },
        ],
      },
      groups: [],
      operators: [],
      values: [],
      overview: {},
      recipients: [],
      loadingOverview: true,
      keyValues: [],
      page: 0,
      count: 10,
      startCountPag: 1,
      endCountPag: 10,
      modalConfirmCancel: false,
      modalSaveSegment: false,
      loading: true,
      loadingRecipients: false,
      btnSaveSegmentClicked: false,
      headers: [],
      pages: 1,
      totalRecords: 0,
      tags: [],
      pagination: {},
    }
  },
  mounted() {
    this.getClientSegment() //getGroups
    this.getOperator() //getOperators
    this.clearOverviewValue()
    this.getAudienceScheme()

    /*this.getOverView({
      organizationId: this.organizationId,
      query: {}
    });*/

    //this.getValuesByKey("Nothing");
  },

  methods: {
    getAudienceScheme() {
      services
        .audienceSchema(this.$route.params.organizationId)
        .then((schema) => {
          for (var i = 0; i < schema.data.data.tags.length; i++) {
            this.tags.push({
              value: schema.data.data.tags[i],
              label: schema.data.data.tags[i],
            })
          }
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },
    paginationChange(a) {
      this.count = a
    },
    headerHandle(arr) {
      let headers = arr.reduce((acc, cur) => {
        const isKey = cur.isKey ? 'KeyColumn' : ''
        acc.push({
          key: cur.fieldName,
          label: cur.value,
          isKey: cur.isKey,
          _classes: isKey,
          _style: cur.value == 'SMS' ? 'min-width:180px' : '',
        })
        return acc
      }, [])

      return [...headers, ...columnAplication]
    },

    async getHeaders(organizationId) {
      services
        .audienceSchema(organizationId)
        .then((schema) => {
          this.headers = this.headerHandle(schema.data.data.values)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    addCondition: function () {
      this.segments.values.push({
        op: 'or',
        values: [
          {
            group: null,
            key: '',
            value: '',
            op: '',
            next: {
              key: '',
              value: '',
              op: '',
              next: {},
            },
          },
        ],
      })

      this.inputText.push([''])
      this.form.push([''])
    },

    getValueByGroupName: function (groupName) {
      let gp = this.groups.find((item) => item.group === groupName)
      return gp.values.map((item) => {
        return {
          value: item.key,
          label: item.name,
        }
      })
    },

    getValuesByKey: function (key) {
      var len = this.groups.length
      let lv = []
      for (var i = 0; i < len; i++) {
        if (!this.values.length) {
          this.recursiveVerifyKey(this.groups[i].values, key)
        }
        lv = this.values
        this.values = []
        if (lv.length) {
          break
        }
      }

      return lv.map((item) => {
        return {
          value: item.key,
          label: item.value,
        }
      })
    },

    recursiveVerifyKey: function (item, key) {
      if (!item.length) {
        return
      }

      if (this.values.length) {
        return
      }
      for (let i = 0; i < item.length; i++) {
        if (item[i].key === key) {
          this.values = item[i].values
          break
        }
        this.keyValues.push({
          key: item[i].key,
          type: item[i].type,
          values: item[i].values,
        })
        this.recursiveVerifyKey(item[i].values, key)
      }
    },

    getValuesInKeyGroup: function (key) {
      let values = this.keyValues.filter((el) => el.key == key) || []

      // Conceito inserido no ambito da task 2053
      if (values[0].type === 'BOOLEAN')
        return [
          {
            value: true,
            label: 'true',
          },
          {
            value: false,
            label: 'false',
          },
        ]

      return values.map((item) => {
        return {
          value: item.key,
          label: item.value,
        }
      })
    },

    getKeyType: function (key) {
      const value = this.keyValues.find((el) => el.key === key)
      return value?.type
    },

    getOperationsInKeyGroup: function (key) {
      let type = null

      this.keyValues.find((item) => {
        if (item.key === key) {
          type = item.type
        }
      })

      if (type === 'EMAIL') {
        type = 'STRING'
      }

      if (type === 'MSISDN') {
        type = 'STRING'
      }
      return this.operators
        .map((item) => {
          if (item.type === type) {
            return item.operators
              .filter((el) => el.isActive)
              .map((prop) => {
                return {
                  value: prop.name,
                  label: prop.label,
                }
              })
          }
        })
        .filter((element) => element !== undefined)
    },

    addOrCondition: function (indexSeg) {
      this.segments.values[indexSeg].values.push({ group: null, key: '', value: '', op: null, next: { key: '', value: '', op: '', next: {} } })
    },

    getSelectOptions: function (item) {
      return {
        value: item.key,
        label: item.next.value,
      }
    },

    deleteOrCondition: function (indexSeg, indexOr) {
      if (indexSeg == 0 && indexOr > 0) {
        this.segments.values[indexSeg].values.splice(indexOr, 1)
      } else if (indexSeg > 0 && indexOr > 0) {
        this.segments.values[indexSeg].values.splice(indexOr, 1)
      } else if (indexSeg > 0 && indexOr == 0) {
        this.segments.values.splice(indexSeg, 1)
      }
      this.waitToGetOverView()
    },

    changeGroup: function (group, indexSeg, indexOr) {
      this.groupName = group
      // let len = this.groups.length
      // let groupValues = []
      // let keys = []

      // for (let i = 0; i < len; i++) {
      //   if (this.groups[i].group == group) {
      //     groupValues = this.groups[i].values
      //   }
      // }
      this.segments.values[indexSeg].values.splice(indexOr, 1, {
        group: group,
        key: '',
        value: '',
        op: '',
        next: {
          key: '',
          value: '',
          op: '',
          next: {},
        },
      })

      this.addKeys()
    },

    addKey: function (key, indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].key = key
      this.segments.values[indexSeg].values[indexOr].value = key
      //this.inputText = '';
      this.waitToGetOverView()
      return
    },

    addKey2: function (key, indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].next.key = key
      this.segments.values[indexSeg].values[indexOr].next.value = key
      this.waitToGetOverView()
      return
    },

    // Foi criado no âmbito da atividade ARP-2053, para sanar o problema relacionado a key do campo
    addKey3: function (key, indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].next.key = ''
      this.segments.values[indexSeg].values[indexOr].next.value = key
      this.waitToGetOverView()
      return
    },

    addCustomToJson: function (indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].next.key = this.inputCustom.toString()
      this.segments.values[indexSeg].values[indexOr].next.value = this.inputCustom.toString()
      return
    },

    addDateToJson: function (indexSeg, indexOr) {
      // this.segments.values[indexSeg].values[indexOr].next.key = this.inputCustom.toString()
      this.segments.values[indexSeg].values[indexOr].next.value = this.inputCustom.toString()
      return
    },

    addTextValueToJson: function (indexSeg, indexOr, value) {
      this.segments.values[indexSeg].values[indexOr].next.key = '' //vazio pois o backend está com bug, ver conversa com Paulo
      this.segments.values[indexSeg].values[indexOr].next.value = value
      this.inputText[indexSeg][indexOr] = value
      this.waitToGetOverView()
    },

    addTagValueToJson(indexSeg, indexOr, value) {
      this.segments.values[indexSeg].values[indexOr].next.key = ''
      this.segments.values[indexSeg].values[indexOr].next.value = value
      this.inputText[indexSeg][indexOr] = value
      this.waitToGetOverView()
    },

    waitToGetOverView() {
      if (this.timeoutOverview) clearTimeout(this.timeoutOverview)
      this.timeoutOverview = setTimeout(() => {
        this.getClientOverview(true)
      }, 1000)
    },

    onTableChange() {
      this.getClientOverview(false)
    },

    getClientOverview() {
      this.loadingRecipients = true
      let body = {
        pageOptions: {
          count: this.count,
          page: this.page - 1 <= 0 ? 0 : this.page - 1,
          // page: 0,
          // page: inputClient ? 0 : this.page - 1,
        },
        query: this.segments,
      }

      services
        .getClientOverview(this.organizationId, body)
        .then((response) => {
          this.overview = response.data.data
          this.recipients = response.data.data.recipientResult.recipients
          this.pages = response.data.data.recipientResult.pagination.totalPages
          this.pagination.totalPages = response.data.data.recipientResult.pagination.totalPages
          this.pagination.page = response.data.data.recipientResult.pagination.currentPage + 1
          this.totalRecords = response.data.data.recipientResult.pagination.totalRecords
          this.page = response.data.data.recipientResult.pagination.currentPage + 1
          this.loading = false
          this.setOverviewValue(response.data.data)
        })
        .catch(() => {
          //this.openAlertMessage('danger', 'Your query contains errors, please review the applied filters.');
          //this.scrollTop();
        })
        .finally(() => (this.loadingRecipients = false))
    },

    openAlertMessage(alertClass, alertMessage) {
      this.currentAlertCounter = 10
      this.alertClass = alertClass
      this.alertMessage = alertMessage
    },

    changeOperator: function (op, indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].next.op = op
      this.form[indexSeg][indexOr] = op
      this.waitToGetOverView()
    },

    addOperationsByType: function () {},

    getOperator() {
      services
        .getOperators()
        .then((response) => {
          this.operators = response.data.data
        })
        .catch(() => {})
    },

    getClientSegment() {
      services
        .getClientSegment(this.organizationId)
        .then((response) => {
          this.groups = response.data.data
          this.getValuesByKey('Nothing')
        })
        .catch(() => {})
    },

    addKeys() {
      let groups = this.groups
      for (var i = 0; i < groups.length; i++) {
        for (var j = 0; j < groups[i].values.length; j++) {
          this.keyValues.push({
            key: groups[i].values[j].key,
            type: groups[i].values[j].type,
            values: groups[i].values[j].values,
            name: groups[i].values[j].name,
          })
        }
      }
    },

    saveSegment() {
      const organizationId = this.organizationId
      const name = this.segmentName
      const query = this.segments
      services
        .postSegment({ organizationId, name, query })
        .then((response) => {
          alert('Save Segments', response.data.status)
        })
        .catch(() => {})
    },

    cancelSegment() {
      this.form = []
      this.segments = {
        op: 'and',
        values: [
          {
            op: 'or',
            values: [
              {
                group: null,
                key: '',
                value: '',
                op: null,
                next: {
                  key: '',
                  value: '',
                  op: '',
                  next: {},
                },
              },
            ],
          },
        ],
      }
    },

    getOverView(payload) {
      this.loadingOverview = true
      services
        .getOverview(payload)
        .then((response) => {
          this.overview = response.data
          this.loadingOverview = false
        })
        .catch(() => {
          this.loadingOverview = false
        })
    },

    updateOverview() {
      const organizationId = this.organizationId
      const query = this.segments

      this.getOverView({ organizationId, query })
    },

    openModalConfirmCancel() {
      this.modalConfirmCancel = true
    },

    closeModalCancel() {
      this.modalConfirmCancel = false
    },

    openModalSaveSegment() {
      this.modalSaveSegment = true
    },

    closeModalSaveSegment() {
      this.modalSaveSegment = false
    },

    verifyPagination() {
      if (this.page === 0) {
        return 1
      }

      if (this.page > 0) {
        return 0
      }
    },

    verifyPaginationNext(count) {
      if (count < 10) {
        return 1
      }

      if (count >= 10) {
        return 0
      }
    },

    createSegment: function () {
      this.btnSaveSegmentClicked = true

      if (this.segmentName === '') {
        this.openAlertMessage('danger', 'You must enter a name for this segment.')
        this.scrollTop()
        this.modalSaveSegment = false
        this.btnSaveSegmentClicked = false
      } else {
        let body = {
          organizationId: this.organizationId,
          name: this.segmentName,
          group: 'CONTACT_FIELDS', //rever necessidade de ter o group pois poderão existir vários na msm query
          defaultField: null,
          query: this.segments,
        }

        services
          .createSegment(this.organizationId, body)
          .then((response) => {
            this.modalSaveSegment = false
            this.btnSaveSegmentClicked = false
            if (this.$route.params.campaignId) {
              this.generateDataForCampaign(response.data.data.segmentId, response.data.data.name)
              return
            }

            this.$router.push({
              name: 'segments-list',
              params: { message: 'Segment ' + this.segmentName + ' successfully created!', status: 'success' },
            })
          })
          .catch(() => {
            this.modalSaveSegment = false
            this.btnSaveSegmentClicked = false
            this.openAlertMessage('danger', 'Your query contains errors, please review the applied filters.')
            this.scrollTop()
          })
      }
    },

    generateDataForCampaign(segmentId, name) {
      const NEW_SEGMENT = { segmentId: segmentId, name: name }

      this.$router.push({
        name: 'campaignCreator',
        params: {
          messages: [
            {
              status: 'success',
              text: `segment ${this.segmentName} was successfully created and added to your campaign`,
            },
          ],
          campaignId: this.$route.params.campaignId,
          channel: this.$route.params.channel,
          newSegment: NEW_SEGMENT,
        },
      })
    },

    scrollTop: function () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },

    counterTable(count) {
      if (count < 10) {
        return count
      } else {
        return this.endCountPag
      }
    },

    getNameFromKeyValues(key) {
      let name = ''

      for (let i = 0; i < this.keyValues.length; i++) {
        if (this.keyValues[i].key === key) {
          name = this.keyValues[i].name
          break
        }
      }

      return name
    },

    setOverviewValue(overview) {
      this.$store.commit('UPDATE_OVERVIEW', overview)
    },

    clearOverviewValue() {
      let overview = {}
      overview.contacts = 0
      overview.contactsPercentageOfTotal = 0
      overview.reachSegmentPercentage = 0
      this.$store.commit('UPDATE_OVERVIEW', overview)
    },
  },

  computed: {
    organizationId() {
      return this.$store.state.auth.organizationId
    },

    getGroupOptions: function () {
      let gp = this.groups.map((item) => {
        return {
          value: item.group,
          label: this.$t(`audience.segment.group.${item.group}`),
        }
      })
      return gp
    },

    detailPagination() {
      const first = (this.page - 1) * this.count + 1
      return `${first} - ${this.page * 10}  of ${this.totalRecords}`
    },

    reloadParams() {
      return [this.page, this.count]
    },
  },

  created() {
    this.getHeaders(this.organizationId)
  },

  watch: {
    reloadParams: {
      handler(newValue, oldValue) {
        // TODO precisei fazer isso para impedir 2 requisições ao entrar na pagina.
        // caso entre mais props no getdata() terá que mudar o indice do array newValue[3], oldValue[3]
        // newValue[3] pagina atual -  oldValue[3] pagina antiga
        if (newValue[0] == 1 && oldValue[0] == 0) return
        this.onTableChange()
      },
    },
  },
}
</script>
<style scope>
.position-sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 27px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 21px;
  width: 21px;
  left: 6px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #71d875;
}

input:focus + .slider {
  box-shadow: 0 0 1px #71d875;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.dropdown-toggle {
  border: 1px solid #c9c9c9 !important;
}

.btnAddAnd {
  border-radius: 2px;
  -webkit-box-shadow: 1px 9px 4px -7px rgba(181, 181, 181, 0.3);
  -moz-box-shadow: 1px 9px 4px -7px rgba(181, 181, 181, 0.3);
  box-shadow: 1px 9px 4px -7px rgba(181, 181, 181, 0.3);
  border: solid 1px #d1d4da;
  padding: 8px;
  border-radius: 1px;
  text-align: center;
  color: #405a76;
  cursor: pointer;
  background-color: #f5f5f5;
  font-size: 12px;
}

.btnAddAnd img {
  width: 20px;
  height: 20px;
}

.btnAddAnd span {
  text-decoration: underline #405a76;
}

.btn-segment-create {
  color: white !important;
  text-decoration: none !important;
  float: right;
  padding: 0.8rem 1.5rem;
  font-weight: bold;
}

.btn-segment-overview {
  color: #7f889a;
  text-decoration: none !important;
  float: right;
  padding: 0.8rem 1.5rem;
}

.boxTitle {
  font-size: 28px;
  color: #373737;
}

.paginationText {
  color: #a1a8b3;
  line-height: 3;
}

.boxPag {
  background-color: #fff;
  width: 50px;
  height: 45px;
  line-height: 2.9;
  text-align: center;
  color: #d1d4da;
  cursor: pointer;
}

.boxPag:hover {
  background-color: #edeff1;
}

.box-pag-bg-disable {
  background-color: #edeff1 !important;
}
</style>
<style module>
.blockClick {
  pointer-events: none;
}
</style>
